import array from '@mailobj-browser/front/js/utils/array.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import draw from './draw.js'
import attach from './attach/attach.js'
import docs from './docs/docs.js'
import camera from './camera/camera.js'
import backdrop from './backdrop.js'
import links from "./links.js";

export default contract({
  attach,
  backdrop: array([
    backdrop
  ]),
  camera,
  docs,
  draw,
  links: array([
    links
  ])
})